import styled from 'styled-components';
import { Link } from 'react-router-dom';

const TeamLink = styled(Link)`
  color: inherit;
  text-decoration: underline;
`;

export const Styled = {
  TeamLink,
};
